export class NetServiceImpl {
    public backendPrefix = 'https://backend.motherfaker.dad';

    public ossPrefix = 'https://music-oss.motherfaker.dad';
}

export const NetServiceUtil = new NetServiceImpl();
